// extracted by mini-css-extract-plugin
export default {"login":"login_login__IVFg2","login__panel":"login_login__panel__m7yVh"};